import { render } from "./deleteCountComponent.vue?vue&type=template&id=3c641fe4"
import script from "./deleteCountComponent.vue?vue&type=script&lang=js"
export * from "./deleteCountComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__